import { tokenRequestOptions, tokenRequestOptionsForMultipart } from "../store/actions/LoginActions";
import { AdjustmentDto } from "../store/models/adjustment/AdjustmentDto";
import { AppLinkDto } from "../store/models/appcontent/AppLinkDto";
import { AppSplashDto } from "../store/models/appcontent/AppSplashDto";
import { CarouselDto } from "../store/models/appcontent/CarouselDto";
import { CarouselInboundDto } from "../store/models/appcontent/CarouselInboundDto";
import { BonusRuleDto, FilterDto } from "../store/models/bonusRule/BonusRuleDto";
import { BonusRuleStatus } from "../store/models/bonusRule/BonusRuleStatus";
import { BonusXpressDto } from "../store/models/bonusXpress/BonusXpressDto";
import {
  CampaignExperimentalListResponseDto,
  CampaignExperimentalSearchRequestDto,
} from "../store/models/campaignExperimental/CampaignExperimentalDto";
import { CampaignFormDto } from "../store/models/campaignExperimental/CampaignFormDto";
import { CampaignApiSearchRequestDto } from "../store/models/campaignExperimental/CampaignApiDto";
import { CampaignMapper } from "../store/models/campaignExperimental/CampaignMapper";
import { CashbackDto } from "../store/models/cashback/CashbackDto";
import { CircleDto } from "../store/models/circle/CircleDto";
import { ConfigDto, ConfigGroupDto, ConfigValueDto, HubConfigDto } from "../store/models/config/ConfigDto";
import { ConfigGroupKey } from "../store/models/config/ConfigGroupKey";
import { CouponTemplateAssignmentDto, CreateCouponTemplateRequest } from "../store/models/coupon/CouponManagementDto";
import { CollectionIntervalDto } from "../store/models/customer/CollectionIntervalDto";
import { CustomerBonusPointsDto } from "../store/models/customer/CustomerBonusPointsDto";
import { CustomerCustomFieldDto } from "../store/models/customer/CustomerCustomFieldDto";
import { CustomerDto } from "../store/models/customer/CustomerDto";
import { CustomerInteractionDto } from "../store/models/customer/CustomerInteractionDto";
import { CustomerNumberDto } from "../store/models/customer/CustomerNumberDto";
import { CustomerSearchDto } from "../store/models/customer/CustomerSearchDto";
import { CustomerStatusDto } from "../store/models/customer/CustomerStatusDto";
import { MembershipCancellationDto } from "../store/models/customer/MembershipCancellationDto";
import { ReceiptDetailsDto } from "../store/models/customer/ReceiptDetailsDto";
import { InteractionKpiDayDto } from "../store/models/dashboard/InteractionKpiDayDto";
import { EinGeneratorTemplateDto } from "../store/models/eingeneratortemplate/EinGeneratorTemplateDto";
import { FamilyDto } from "../store/models/family/FamilyDto";
import { FamilyMembersDto } from "../store/models/family/FamilyMembersDto";
import { FamilyMembershipDto, FamilyMembershipRole } from "../store/models/family/FamilyMembershipDto";
import { ConfigTypes, FieldConfigDto } from "../store/models/fieldConfig/FieldConfigDto";
import { FlowDetailsDto, FlowGroupDto } from "../store/models/flow/FlowDto";
import { GdprRequestDto } from "../store/models/gdpr/GdprRequestDto";
import { GdprTemplates } from "../store/models/gdpr/GdprTemplate";
import { CustomerHistoryDto } from "../store/models/history/HistoryDto";
import { CustomerIdentificationDto } from "../store/models/identification/CustomerIdentificationDto";
import { CardDesignDto } from "../store/models/carddesign/CardDesignDto";
import { ReplacementIdentifactionDto } from "../store/models/identification/ReplacementIdentifactionDto";
import { InteractionSearchDto } from "../store/models/interactionSearch/InteractionSearchDto";
import { InteractionSearchResponseDto } from "../store/models/interactionSearch/InteractionSearchResponseDto";
import { InvitationDto } from "../store/models/InvitationDto";
import { OperationalUnitDto } from "../store/models/operationalUnit/OperationalUnitDto";
import { OperationalUnitType } from "../store/models/operationalUnit/OperationalUnitType";
import { PassRequestDto } from "../store/models/pass/PassRequestDto";
import { CustomerPreferenceDto } from "../store/models/preferences/CustomerPreferenceDto";
import { PreferenceDto } from "../store/models/preferences/PreferenceDto";
import { QuestionDto } from "../store/models/preferences/QuestionDto";
import { BranchStoreDto } from "../store/models/registration/BranchStoreDto";
import { RegistrationCustomerDto } from "../store/models/registration/RegistrationCustomerDto";
import { RegistrationDto } from "../store/models/registration/RegistrationDto";
import { RewardsDto } from "../store/models/rewards/RewardsDto";
import { PaginationSegmentsDto } from "../store/models/segments/PaginationSegmentsDto";
import { SegmentDto } from "../store/models/segments/SegmentDto";
import { SegmentLinkedBonusRuleDto, SegmentLinkedCampaignDto } from "../store/models/segments/SegmentReferencesDto";
import { UpdateSegmentMembershipRequest } from "../store/models/segments/UpdateSegmentMembershipRequest";
import { UpdateSegmentRequest } from "../store/models/segments/UpdateSegmentRequest";
import { ChangePasswordDto } from "../store/models/user/ChangePasswordDto";
import { UserDto, OTPDevice } from "../store/models/user/UserDto";
import { fetchWithTenant } from "./TenantUtils";
import { SegmentMembershipHistoryDto } from "../store/models/segments/SegmentMembershipHistoryDto";
import { AISegmentGroupApiResponse } from "../store/models/segments/AISegmentGroup";
import { ReceiptDto } from "../store/models/receipt/ReceiptDto";
import { PaginatedReceiptResponse } from "../store/models/receipt/PaginatedReceiptResponse";
import { AnalysisValueDto } from "../store/models/segments/AnalysisValue";
import { CustomerFieldConfig } from "../components/segments/builder/adhoc/types/AdHocTypes";
import { EasySegmentCreateRequest } from "../components/segments/builder/adhoc/types/AdHocTypes";

const REACT_APP_SERVER_URL = window.env.REACT_APP_SERVER_URL || process.env.REACT_APP_SERVER_URL;

const customerCareUrl =
  window.env.REACT_APP_CUSTOMER_CARE_URL ||
  process.env.REACT_APP_CUSTOMER_CARE_URL ||
  `${REACT_APP_SERVER_URL}/customercare/v1`;
const bonusManagementUrl =
  window.env.REACT_APP_BONUS_MANAGEMENT_URL ||
  process.env.REACT_APP_BONUS_MANAGEMENT_URL ||
  `${REACT_APP_SERVER_URL}/bonusmanagement/v1`;
const customerInteractionUrl =
  window.env.REACT_APP_CUSTOMER_INTERACTION_URL ||
  process.env.REACT_APP_CUSTOMER_INTERACTION_URL ||
  `${REACT_APP_SERVER_URL}/customerinteraction/v1`;
const adminUserManagementUrl =
  window.env.REACT_APP_ADMIN_USER_MANAGEMENT_URL ||
  process.env.REACT_APP_ADMIN_USER_MANAGEMENT_URL ||
  `${REACT_APP_SERVER_URL}/adminusermanagement/v1`;
const appContentUrl =
  window.env.REACT_APP_ADMIN_APP_CONTENT_URL ||
  process.env.REACT_APP_ADMIN_APP_CONTENT_URL ||
  `${REACT_APP_SERVER_URL}/appcontent/v1`;
const historyUrl =
  window.env.REACT_APP_HISTORY_URL || process.env.REACT_APP_HISTORY_URL || `${REACT_APP_SERVER_URL}/history/v1`;
const dashboardUrl =
  window.env.REACT_APP_DASHBOARD_URL || process.env.REACT_APP_DASHBOARD_URL || `${REACT_APP_SERVER_URL}/dashboard/v1`;
const identityManagementUrl =
  window.env.REACT_APP_IDENTITY_MANAGEMENT_URL ||
  process.env.REACT_APP_IDENTITY_MANAGEMENT_URL ||
  `${REACT_APP_SERVER_URL}/identitymanagement/v1`;
const flowEngineUrl =
  window.env.REACT_APP_FLOW_ENGINE_URL ||
  process.env.REACT_APP_FLOW_ENGINE_URL ||
  `${REACT_APP_SERVER_URL}/flowengine/v1`;
const segmentsUrl =
  window.env.REACT_APP_SEGMENTS_URL || process.env.REACT_APP_SEGMENTS_URL || `${REACT_APP_SERVER_URL}/segments/v1`;
const customerInactivityUrl =
  window.env.REACT_APP_CUSTOMER_INACTIVITY_URL ||
  process.env.REACT_APP_CUSTOMER_INACTIVITY_URL ||
  `${REACT_APP_SERVER_URL}/inactivityprediction/v1`;
const customerLifetimeValueUrl =
  window.env.REACT_APP_CUSTOMER_LIFETIME_VALUE_URL ||
  process.env.REACT_APP_CUSTOMER_LIFETIME_VALUE_URL ||
  `${REACT_APP_SERVER_URL}/clvprediction/v1`;
const receiptScanningUrl =
  window.env.REACT_APP_RECEIPT_SCANNING_URL ||
  process.env.REACT_APP_RECEIPT_SCANNING_URL ||
  `${REACT_APP_SERVER_URL}/receipt-scanning/v1`;
const couponUrl =
  window.env.REACT_APP_COUPON_URL ||
  process.env.REACT_APP_COUPON_URL ||
  `${REACT_APP_SERVER_URL}/coupons/v1`;
const hubConfigsUrl =
  window.env.REACT_APP_HUB_CONFIGS_URL ||
  process.env.REACT_APP_HUB_CONFIGS_URL ||
  `${REACT_APP_SERVER_URL}/hub-configs/v1`;

/**
 * The unit write endpoints are multipart: the unit travels as the JSON `data` part and an optional
 * branch image as the `file` part. This app maintains no branch image, so it only sends `data`; the
 * absent file part leaves any image uploaded elsewhere untouched.
 */
// The unit write endpoints are multipart with one part per field; only the nested contact is a JSON part (LH-3761).
const operationalUnitFormData = (operationalUnit: OperationalUnitDto): FormData => {
  const formData = new FormData();
  const text = (name: string, value: string | undefined) => {
    if (value) {
      formData.append(name, value);
    }
  };
  text("unitNumber", operationalUnit.unitNumber);
  text("unitName", operationalUnit.unitName);
  text("externalUnitNumber", operationalUnit.externalUnitNumber);
  text("unitType", operationalUnit.unitType);
  text("parentUnitNumber", operationalUnit.parentUnitNumber);
  if (operationalUnit.contact) {
    formData.append(
      "contact",
      new Blob([JSON.stringify(operationalUnit.contact)], { type: "application/json" })
    );
  }
  return formData;
};

export const Api = {
  getFamilyByCustomerNumber: async (customerNumber: string): Promise<FamilyDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${customerCareUrl}/admin/families${objectToQueryString({
        customerNumber,
      })}`,
      requestOptions
    ).then(handleResponse);
  },
  deleteFamilyMembership: async (familyNumber: string, customerNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${customerCareUrl}/admin/families/${familyNumber}/membership`, {
      ...requestOptions,
      body: JSON.stringify({
        customerNumber,
      }),
    }).then(handleResponse);
  },
  updateFamilyMemberRoles: async (familyNumber: string, familyRoles: FamilyMembersDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/admin/families/${familyNumber}/member-roles`, {
      ...requestOptions,
      body: JSON.stringify(familyRoles),
    }).then(handleResponse);
  },
  inviteFamilyMember: async (invitation: InvitationDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/admin/invite`, {
      ...requestOptions,
      body: JSON.stringify(invitation),
    }).then(handleResponse);
  },
  transferFamilyMember: async (familyNumber: string, customerNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    const family: FamilyMembershipDto = {
      customerNumber: customerNumber,
      roleName: FamilyMembershipRole.MEMBER,
    };
    return fetchWithTenant(`${customerCareUrl}/admin/families/${familyNumber}/memberships`, {
      ...requestOptions,
      body: JSON.stringify(family),
    }).then(handleResponse);
  },
  getCustomerHistory: async (customerNumber: string): Promise<CustomerHistoryDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${historyUrl}/history${objectToQueryString({ customerNumber })}`, requestOptions).then(
      handleResponse
    );
  },
  getQuestions: async (): Promise<PreferenceDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerCareUrl}/preferences`, requestOptions).then(handleResponse);
  },
  updateQuestion: async (question: QuestionDto): Promise<QuestionDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/preferences/questions/${question.questionNumber}`, {
      ...requestOptions,
      body: JSON.stringify(question),
    }).then(handleResponse);
  },
  createQuestion: async (question: QuestionDto): Promise<QuestionDto> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/preferences/questions`, {
      ...requestOptions,
      body: JSON.stringify(question),
    }).then(handleResponse);
  },
  deleteQuestion: async (question: QuestionDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${customerCareUrl}/preferences/questions/${question.questionNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCustomerPreferences: async (customerNumber: string): Promise<PreferenceDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}/preferences`, requestOptions).then(
      handleResponse
    );
  },
  updateCustomerPreferences: async (customerPreferences: CustomerPreferenceDto[], customerNumber: string) => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}/preferences`, {
      ...requestOptions,
      body: JSON.stringify(customerPreferences),
    }).then(handleResponse);
  },
  getAllBonusRules: async (): Promise<BonusRuleDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/rules?size=1000`, requestOptions)
      .then(handleResponse)
      .then((page) => page.data);
  },
  getBonusRulePage: async (query: {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: string;
    name?: string;
    status?: BonusRuleStatus;
    running?: boolean;
    unitNumbers?: string[];
  }): Promise<{ data: BonusRuleDto[]; total: number }> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/rules${objectToQueryString(query)}`, requestOptions).then(handleResponse);
  },
  createBonusRule: async (bonusRule: BonusRuleDto): Promise<BonusRuleDto> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${bonusManagementUrl}/rules`, {
      ...requestOptions,
      body: JSON.stringify(bonusRule),
    }).then(handleResponse);
  },
  createBonusRuleWithFile: async (formData: FormData): Promise<BonusRuleDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${bonusManagementUrl}/rules/upload`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  updateBonusRuleStatus: async (ruleNumber: string, status: BonusRuleStatus): Promise<BonusRuleDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/rules/${ruleNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify({ status }),
    }).then(handleResponse);
  },
  deleteBonusRule: async (bonusRule: BonusRuleDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${bonusManagementUrl}/rules/${bonusRule.ruleNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateBonusRule: async (bonusRule: BonusRuleDto): Promise<BonusRuleDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/rules/${bonusRule.ruleNumber}`, {
      ...requestOptions,
      body: JSON.stringify(bonusRule),
    }).then(handleResponse);
  },
  addBonusRuleFilter: async (formData: FormData, ruleNumber: string): Promise<FilterDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${bonusManagementUrl}/rules/${ruleNumber}/filter`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  updateBonusRuleFilter: async (formData: FormData, ruleFilterNumber: string): Promise<FilterDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/rules/filter/${ruleFilterNumber}`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  deleteBonusRuleFilter: async (ruleFilterNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptionsForMultipart("DELETE");
    return fetchWithTenant(`${bonusManagementUrl}/rules/filter/${ruleFilterNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  findFilterValues: async (filterNumber: string): Promise<string[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/propertygroups/${filterNumber}/values`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getExternalCustomerId: async (cardNumber: string): Promise<CustomerNumberDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${identityManagementUrl}/admin/cards/${cardNumber}/customer`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  customerSearch: async (customerSearch: CustomerSearchDto): Promise<CustomerDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    const queryString = objectToQueryString(customerSearch);
    return fetchWithTenant(`${customerCareUrl}/admin/customers/customersearch${queryString}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  findCustomer: async (customerNumber: string): Promise<CustomerDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateCustomer: async (customer: CustomerDto): Promise<CustomerDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customer.customerNumber}`, {
      ...requestOptions,
      body: JSON.stringify(customer),
    }).then(handleResponse);
  },

  updateCustomerStatus: async (customerNumber: string, customerStatus: CustomerStatusDto): Promise<CustomerDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/customers/customerNumber/${customerNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify(customerStatus),
    }).then(handleResponse);
  },
  createAdjustmentEarn: async (adjustment: AdjustmentDto): Promise<AdjustmentDto> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(
      `${customerInteractionUrl}/admin/adjustmentinteractions/earn/customers/${adjustment.customerNumber}`,
      {
        ...requestOptions,
        body: JSON.stringify(adjustment),
      }
    ).then(handleResponse);
  },
  createAdjustmentBurn: async (adjustment: AdjustmentDto): Promise<AdjustmentDto> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(
      `${customerInteractionUrl}/admin/adjustmentinteractions/burn/customers/${adjustment.customerNumber}`,
      {
        ...requestOptions,
        body: JSON.stringify(adjustment),
      }
    ).then(handleResponse);
  },
  getRewards: async (customerNumber: string): Promise<RewardsDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/customers/${customerNumber}/rewards`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCustomerCollectionInterval: async (customerNumber: string): Promise<CollectionIntervalDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${flowEngineUrl}/admin/customer/circle/upgrade${objectToQueryString({
        customerNumber,
      })}`,
      requestOptions
    ).then(handleResponse);
  },
  getAllCampaignsExperimental: async (
    searchRequest?: CampaignExperimentalSearchRequestDto
  ): Promise<CampaignExperimentalListResponseDto> => {
    const requestOptions = await tokenRequestOptions("GET");

    const apiSearchRequest: CampaignApiSearchRequestDto = {
      page: searchRequest?.pageNumber || 1,
      size: searchRequest?.pageSize || 10,
      sortBy: searchRequest?.sortBy || "creationTimestamp",
      sortDirection: searchRequest?.sortDirection || "desc",
      types: searchRequest?.filters?.campaignType,
      status: searchRequest?.filters?.status,
      name: searchRequest?.filters?.name,
      startDateFrom: searchRequest?.filters?.startDateFrom,
      startDateTo: searchRequest?.filters?.startDateTo,
      endDateFrom: searchRequest?.filters?.endDateFrom,
      endDateTo: searchRequest?.filters?.endDateTo,
    };

    const queryParams = objectToQueryString(apiSearchRequest);
    const fullUrl = `${couponUrl}/campaigns${queryParams}`;

    return fetchWithTenant(fullUrl, {
      ...requestOptions,
    })
      .then(handleResponse)
      .then((apiResponse) =>
        CampaignMapper.mapApiResponseToFrontend(apiResponse, apiSearchRequest.page || 1, apiSearchRequest.size || 10)
      );
  },
  getCampaignExperimentalByNumber: async (campaignNumber: string) => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createCampaignExperimental: async (
    campaign: CampaignFormDto
  ): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    const apiRequest = CampaignMapper.mapFormDataToApiRequest(campaign);

    await fetchWithTenant(`${couponUrl}/campaigns`, {
      ...requestOptions,
      body: JSON.stringify(apiRequest),
    }).then(handleResponse);
  },
  updateCampaignExperimental: async (
    campaignNumber: string,
    campaign: CampaignFormDto
  ): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    const apiRequest = CampaignMapper.mapFormDataToApiRequest(campaign);

    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}`, {
      ...requestOptions,
      body: JSON.stringify(apiRequest),
    }).then(handleResponse);
  },
  deleteCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  activateCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}/activate`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deactivateCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}/deactivate`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  completeCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify({ status: "COMPLETED" }),
    }).then(handleResponse);
  },
  cancelCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify({ status: "CANCELLED" }),
    }).then(handleResponse);
  },
  pauseCampaignExperimental: async (campaignNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    await fetchWithTenant(`${couponUrl}/campaigns/${campaignNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify({ status: "PAUSED" }),
    }).then(handleResponse);
  },
  getOperationRootUnitList: async (): Promise<OperationalUnitDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/units/rootlist`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getDefaultOperationalUnitTypes: async (): Promise<OperationalUnitType[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/unittypes`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateOperationalUnit: async (operationalUnit: OperationalUnitDto): Promise<OperationalUnitDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/units/${operationalUnit.unitNumber}`, {
      ...requestOptions,
      body: operationalUnitFormData(operationalUnit),
    }).then(handleResponse);
  },
  updateOperationalUnitStatus: async (operationalUnit: OperationalUnitDto): Promise<OperationalUnitDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/units/${operationalUnit.unitNumber}/states/current`, {
      ...requestOptions,
      body: JSON.stringify({ status: operationalUnit.unitStatus }),
    }).then(handleResponse);
  },
  deleteOperationalUnit: async (operationalUnit: OperationalUnitDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${bonusManagementUrl}/units/${operationalUnit.unitNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createOperationalUnit: async (operationalUnit: OperationalUnitDto): Promise<OperationalUnitDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${bonusManagementUrl}/units`, {
      ...requestOptions,
      body: operationalUnitFormData(operationalUnit),
    }).then(handleResponse);
  },
  findAllUsers: async (): Promise<UserDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${adminUserManagementUrl}/users`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deleteUser: async (user: UserDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${adminUserManagementUrl}/users/${user.userNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createAppLink: async (appLink: AppLinkDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${appContentUrl}/admin/applink`, {
      ...requestOptions,
      body: JSON.stringify(appLink),
    }).then(handleResponse);
  },

  updateAppLink: async (appLink: AppLinkDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${appContentUrl}/admin/applink/${appLink.appLinkNumber}`, {
      ...requestOptions,
      body: JSON.stringify(appLink),
    }).then(handleResponse);
  },

  deleteAppLink: async (appLink: AppLinkDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${appContentUrl}/admin/applink/${appLink.appLinkNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  changeAppLink: async (appLinksToChange: AppLinkDto[]): Promise<AppLinkDto[]> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${appContentUrl}/admin/applink/order/change`, {
      ...requestOptions,
      body: JSON.stringify(appLinksToChange),
    }).then(handleResponse);
  },

  getAllAppLinks: async (): Promise<AppLinkDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${appContentUrl}/admin/applink`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  getSplashImage: async (): Promise<AppSplashDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${appContentUrl}/admin/splashscreen`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  uploadSplashImage: async (formData: FormData): Promise<AppSplashDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${appContentUrl}/admin/splashscreen`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  deleteSplashImage: async (): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${appContentUrl}/admin/splashscreen`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getAllCarousels: async (): Promise<CarouselDto[]> => {
    const requestOptions = await tokenRequestOptionsForMultipart("GET");
    return fetchWithTenant(`${appContentUrl}/admin/carousel`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deleteCarousel: async (carousel: CarouselDto): Promise<void> => {
    const requestOptions = await tokenRequestOptionsForMultipart("DELETE");
    return fetchWithTenant(`${appContentUrl}/admin/carousel/${carousel.carouselNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createCarousel: async (carousel: CarouselInboundDto, imageFile: File): Promise<void> => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(carousel));
    formData.append("file", imageFile);
    const requestOptions = await tokenRequestOptionsForMultipart("POST"); // Add true to indicate FormData
    return fetchWithTenant(`${appContentUrl}/admin/carousel`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  createPass: async (passRequest: PassRequestDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${identityManagementUrl}/passes`, {
      ...requestOptions,
      body: JSON.stringify(passRequest),
    }).then(handleResponse);
  },
  updateCarousel: async (carousel: CarouselInboundDto, imageFile: File, carouselNumber: string): Promise<void> => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(carousel));
    formData.append("file", imageFile);
    const requestOptions = await tokenRequestOptionsForMultipart("PUT");
    return fetchWithTenant(`${appContentUrl}/admin/carousel/${carouselNumber}`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  getCarouselByNumber: async (carouselNumber: string): Promise<CarouselDto> => {
    const requestOptions = await tokenRequestOptionsForMultipart("GET");
    return fetchWithTenant(`${appContentUrl}/admin/carousel/${carouselNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  changeCarousel: async (carouselToChange: CarouselDto[]): Promise<CarouselDto[]> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${appContentUrl}/admin/carousel/order/change`, {
      ...requestOptions,
      body: JSON.stringify(carouselToChange),
    }).then(handleResponse);
  },
  createUser: async (user: UserDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${adminUserManagementUrl}/users`, {
      ...requestOptions,
      body: JSON.stringify(user),
    }).then(handleResponse);
  },
  updateUser: async (user: UserDto): Promise<UserDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${adminUserManagementUrl}/users/${user.userNumber}`, {
      ...requestOptions,
      body: JSON.stringify(user),
    }).then(handleResponse);
  },
  changePassword: async (changePassword: ChangePasswordDto): Promise<void> => {
    delete changePassword.confirmNewPassword;
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${adminUserManagementUrl}/password`, {
      ...requestOptions,
      body: JSON.stringify(changePassword),
    }).then(handleResponse);
  },

  getCashback: async (): Promise<CashbackDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/admin/cashback`, requestOptions).then(handleResponse);
  },
  updateCashback: async (cashbackDto: CashbackDto): Promise<CashbackDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerInteractionUrl}/admin/cashback`, {
      ...requestOptions,
      body: JSON.stringify(cashbackDto),
    }).then(handleResponse);
  },

  getBonusXpress: async (): Promise<BonusXpressDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/bonusxpress`, requestOptions).then(handleResponse);
  },
  updateBonusXpress: async (bonusXpress: BonusXpressDto): Promise<BonusXpressDto> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/bonusxpress`, {
      ...requestOptions,
      body: JSON.stringify(bonusXpress),
    }).then(handleResponse);
  },
  register: async (registration: RegistrationDto): Promise<RegistrationCustomerDto> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/register`, {
      ...requestOptions,
      body: JSON.stringify(registration),
    }).then(handleResponse);
  },
  getBranchStoreList: async (): Promise<BranchStoreDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/units/store`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getRegistrationFieldConfig: async (type: ConfigTypes): Promise<FieldConfigDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${customerCareUrl}/configs/registration/fields${objectToQueryString({
        type,
      })}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
  },
  getCustomerFieldConfig: async (type: ConfigTypes): Promise<FieldConfigDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${customerCareUrl}/configs/customer/fields${objectToQueryString({
        type,
      })}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
  },
  getDashboardKpis: async (date: string): Promise<InteractionKpiDayDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${dashboardUrl}/dashboard/interactions${objectToQueryString({
        date,
      })}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
  },
  findReceiptDetailsForInteraction: async (interactionNumber: string): Promise<ReceiptDetailsDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/interactions/${interactionNumber}/receiptDetails`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  getInteractionDetails: async (interactionNumber: string): Promise<CustomerInteractionDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/interactions/${interactionNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  getBonusPointsInfo: async (customerNumber: string): Promise<CustomerBonusPointsDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInteractionUrl}/customers/${customerNumber}/points`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  cancelCustomerMembership: async (membershipCancellation: MembershipCancellationDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(
      `${customerCareUrl}/admin/customers/${membershipCancellation.customerNumber}/cancel-membership/`,
      {
        ...requestOptions,
        body: JSON.stringify(membershipCancellation),
      }
    ).then(handleResponse);
  },
  revokeCancelCustomerMembership: async (customerNumber?: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}/revoke-cancel-membership/`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  replaceIdentifications: async (
    customerNumber: string,
    replaceIdentificcationDto: ReplacementIdentifactionDto
  ): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${identityManagementUrl}/admin/customers/${customerNumber}/cards/replace`, {
      ...requestOptions,
      body: JSON.stringify(replaceIdentificcationDto),
    }).then(handleResponse);
  },
  createCircle: async (circle: CircleDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${bonusManagementUrl}/circles`, {
      ...requestOptions,
      body: JSON.stringify(circle),
    }).then(handleResponse);
  },
  updateCircle: async (circle: CircleDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${bonusManagementUrl}/circles/${circle.circleNumber}`, {
      ...requestOptions,
      body: JSON.stringify(circle),
    }).then(handleResponse);
  },
  deleteCircle: async (circle: CircleDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${bonusManagementUrl}/circles/${circle.circleNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getAllCircles: async (): Promise<CircleDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/circles`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getEinGeneratorTemplates: async (): Promise<EinGeneratorTemplateDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${identityManagementUrl}/admin/card-number-generator-templates`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createConfigValue: async (configGroupKey: ConfigGroupKey, configValue: ConfigValueDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${hubConfigsUrl}/tenant-configs`, {
      ...requestOptions,
      body: JSON.stringify([toHubConfig(configGroupKey, configValue)]),
    }).then(handleResponse);
  },
  updateConfigValue: async (configGroupKey: ConfigGroupKey, configValue: ConfigValueDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${hubConfigsUrl}/tenant-configs`, {
      ...requestOptions,
      body: JSON.stringify(toHubConfig(configGroupKey, configValue)),
    }).then(handleResponse);
  },
  deleteConfigValue: async (configGroupKey: ConfigGroupKey, configValue: ConfigValueDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${hubConfigsUrl}/tenant-configs/${configGroupKey}/${encodeURIComponent(configValue.key)}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getConfigGroups: async (configGroupKeys: ConfigGroupKey[]): Promise<ConfigGroupDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    const configs: HubConfigDto[] = await fetchWithTenant(
      `${hubConfigsUrl}/tenant-configs?groups=${configGroupKeys.join(",")}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
    return configGroupKeys.map((key) => ({
      key,
      description: "",
      values: configs
        .filter((config) => config.group === key)
        .map((config) => ({ key: config.key, description: config.description ?? "", value: config.value ?? "" })),
    }));
  },
  // Card designs are created through the multipart endpoint; the JSON POST on the same path resolves an existing
  // design for a medium type instead of creating one. An empty media field creates a design without media variants.
  createCardDesign: async (cardDesign: CardDesignDto): Promise<void> => {
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    const formData = new FormData();
    formData.append("name", cardDesign.name);
    formData.append("externalCardDesignNumber", cardDesign.externalCardDesignNumber);
    formData.append("defaultCardDesign", String(cardDesign.defaultCardDesign));
    formData.append("templateName", cardDesign.templateName);
    return fetchWithTenant(`${identityManagementUrl}/card-designs`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  updateCardDesign: async (cardDesign: CardDesignDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${identityManagementUrl}/card-designs/${cardDesign.cardDesignNumber}`, {
      ...requestOptions,
      // description, validFrom and validUntil are overwritten with whatever this request carries, so the values
      // loaded from the list are echoed back. The endpoint ignores name and externalCardDesignNumber.
      body: JSON.stringify({
        description: cardDesign.description,
        isActive: cardDesign.isActive,
        validFrom: cardDesign.validFrom,
        validUntil: cardDesign.validUntil,
        defaultCardDesign: cardDesign.defaultCardDesign,
        templateName: cardDesign.templateName,
      }),
    }).then(handleResponse);
  },
  deleteCardDesign: async (cardDesign: CardDesignDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${identityManagementUrl}/card-designs/${cardDesign.cardDesignNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getAllCardDesigns: async (): Promise<CardDesignDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${identityManagementUrl}/card-designs`, {
      ...requestOptions,
    }).then(handleResponse);
  },

  getCustomerIdentifications: async (customerNumber: string): Promise<CustomerIdentificationDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${identityManagementUrl}/admin/customers/${customerNumber}/cards`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCustomerCustomFields: async (customerNumber: string): Promise<CustomerIdentificationDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}/customfields`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createCustomerCustomField: async (
    customerNumber: string,
    customField: CustomerCustomFieldDto
  ): Promise<CustomerIdentificationDto[]> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/admin/customers/${customerNumber}/customfields`, {
      ...requestOptions,
      body: JSON.stringify(customField),
    }).then(handleResponse);
  },
  updateCustomerCustomField: async (
    customerNumber: string,
    customField: CustomerCustomFieldDto
  ): Promise<CustomerIdentificationDto[]> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(
      `${customerCareUrl}/admin/customers/${customerNumber}/customfields/${customField.fieldName}`,
      {
        ...requestOptions,
        body: JSON.stringify({ fieldValue: customField.fieldValue }),
      }
    ).then(handleResponse);
  },
  deleteCustomerCustomField: async (
    customerNumber: string,
    customField: CustomerCustomFieldDto
  ): Promise<CustomerIdentificationDto[]> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(
      `${customerCareUrl}/admin/customers/${customerNumber}/customfields/${customField.fieldName}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
  },
  createFlow: async (flow: FlowGroupDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows`, {
      ...requestOptions,
      body: JSON.stringify(flow),
    }).then(handleResponse);
  },
  updateFlow: async (flow: FlowGroupDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows/${flow.flowGroupNumber}`, {
      ...requestOptions,
      body: JSON.stringify(flow),
    }).then(handleResponse);
  },
  deleteFlow: async (flow: FlowGroupDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows/${flow.flowGroupNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createFlowDetails: async (flow: FlowDetailsDto, flowGroupNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows/${flowGroupNumber}/details`, {
      ...requestOptions,
      body: JSON.stringify(flow),
    }).then(handleResponse);
  },
  updateFlowDetails: async (flow: FlowDetailsDto, flowGroupNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows/${flowGroupNumber}/details/${flow.flowDetailNumber}`, {
      ...requestOptions,
      body: JSON.stringify(flow),
    }).then(handleResponse);
  },
  deleteFlowDetails: async (flow: FlowDetailsDto, flowGroupNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows/${flowGroupNumber}/details/${flow.flowDetailNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getAllFlows: async (): Promise<FlowGroupDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${flowEngineUrl}/admin/flows`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  interactionSearch: async (interactionSearch: InteractionSearchDto): Promise<InteractionSearchResponseDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    const queryString = objectToQueryString(interactionSearch);
    return fetchWithTenant(`${customerInteractionUrl}/interactionsearch${queryString}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getGdprTemplates: async (): Promise<GdprTemplates> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerCareUrl}/admin/templates/gdpr`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateGdprTemplates: async (gdprTemplate: GdprTemplates): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${customerCareUrl}/admin/templates/gdpr`, {
      ...requestOptions,
      body: JSON.stringify(gdprTemplate),
    }).then(handleResponse);
  },
  createGdprDocument: async (customerNumber: string, gdprRequestDto: GdprRequestDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/admin/templates/gdpr/${customerNumber}`, {
      ...requestOptions,
      body: JSON.stringify(gdprRequestDto),
    }).then((response) => handleFileResponse(response, "DSGVO-Auskunft.pdf"));
  },
  doubleOptIn: async (customerNumber: string, token: string): Promise<ConfigDto[]> => {
    const requestOptions = await tokenRequestOptions("PUT", false);
    return fetchWithTenant(`${customerCareUrl}/customers/${customerNumber}/states/optin?token=${token}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  doubleOptOut: async (customerNumber: string, token: string): Promise<ConfigDto[]> => {
    const requestOptions = await tokenRequestOptions("PUT", false);
    return fetchWithTenant(`${customerCareUrl}/customers/${customerNumber}/states/optout?token=${token}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  downloadPkPass: async (passNumber: string, token: string): Promise<Response> => {
    const requestOptions = await tokenRequestOptions("GET", false);
    return fetchWithTenant(`${identityManagementUrl}/passes/${passNumber}/pkpass?token=${token}`, {
      ...requestOptions,
    }).then((response) => handleFileResponse(response, "pkpass.pkpass"));
  },
  downloadPassForCustomerIdentificationNumber: async (
    customerIdentificationNumber: string,
    token: string
  ): Promise<Response> => {
    const requestOptions = await tokenRequestOptions("GET", false);
    return fetchWithTenant(
      `${identityManagementUrl}/passes/customeridentification/${customerIdentificationNumber}/pkpass?token=${token}`,
      {
        ...requestOptions,
      }
    ).then((response) => handleFileResponse(response, "pkpass.pkpass"));
  },
  createSegment: async (segment: SegmentDto): Promise<void> => {
    const formData = new FormData();
    formData.append("name", segment.name);
    formData.append("externalSegmentId", segment.externalSegmentId);
    formData.append("defaultSegment", segment.defaultSegment ? segment.defaultSegment.toString() : "false");

    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${segmentsUrl}/segments`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  createSegmentWithFile: async (segment: SegmentDto, file: File): Promise<void> => {
    const formData = new FormData();
    formData.append("name", segment.name);
    formData.append("externalSegmentId", segment.externalSegmentId);
    formData.append("defaultSegment", segment.defaultSegment ? segment.defaultSegment.toString() : "false");
    formData.append("file", file);
    formData.append("fileName", file.name);

    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    return fetchWithTenant(`${segmentsUrl}/segments`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  updateSegment: async (segment: SegmentDto): Promise<void> => {
    const { externalSegmentId, name, defaultSegment } = segment;
    const requestOptions = await tokenRequestOptions("PUT");
    let requestBody: UpdateSegmentRequest = { name, defaultSegment };
    return fetchWithTenant(`${segmentsUrl}/segments/${externalSegmentId}`, {
      ...requestOptions,
      body: JSON.stringify(requestBody),
    }).then(handleResponse);
  },
  getSegmentByExternalId: async (externalSegmentId: string): Promise<SegmentDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${segmentsUrl}/segments/${externalSegmentId}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getPaginatedSegments: async (
    searchText?: string,
    types?: string[],
    page?: number,
    size?: number,
    sortBy?: string,
    sortDirection?: string,
    statuses?: string[]
  ): Promise<PaginationSegmentsDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${segmentsUrl}/segments${objectToQueryString({
        searchText,
        types,
        page,
        size,
        sortBy,
        sortDirection,
        statuses,
      })}`,
      {
        ...requestOptions,
      }
    ).then(handleResponse);
  },
  getSegmentLinkedBonusRules: async (externalSegmentId: string): Promise<SegmentLinkedBonusRuleDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${bonusManagementUrl}/rules/segments/${externalSegmentId}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getSegmentLinkedCampaigns: async (externalSegmentId: string): Promise<SegmentLinkedCampaignDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${couponUrl}/campaigns/segments/${externalSegmentId}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deleteSegment: async (segment: SegmentDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${segmentsUrl}/segments/${segment.externalSegmentId}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getAllAssignedSegmentsForCustomer: async (externalCustomerId: string): Promise<SegmentDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${segmentsUrl}/segmentmemberships/externalCustomerId/${externalCustomerId}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getPredictionValuesForCustomer: async (externalCustomerId: string): Promise<AnalysisValueDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${segmentsUrl}/segmentmemberships/externalCustomerId/${externalCustomerId}/predictionValue`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateSegmentMembershipsForCustomer: async (
    externalCustomerId: string,
    request: UpdateSegmentMembershipRequest
  ): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${segmentsUrl}/segmentmemberships/externalCustomerId/${externalCustomerId}`, {
      ...requestOptions,
      body: JSON.stringify(request),
    }).then(handleResponse);
  },
  triggerExportSegmentMemberships: async (externalSegmentId: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${segmentsUrl}/segments/${externalSegmentId}/memberships/export`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  downloadFile: async (type: string, id: string, fileName: string): Promise<string> => {
    const requestOptions = await tokenRequestOptions("GET");
    let url = "";

    if (type === "segment") {
      url = `${segmentsUrl}/segments/${id}/memberships/exported-file/${fileName}`;
    } else {
      throw new Error("Unsupported file type");
    }

    const response = await fetchWithTenant(url, requestOptions);
    const data = await handleResponse(response);
    const downloadUrl = data.downloadUrl;
    return downloadUrl;
  },
  getSegmentMembershipHistory: async (externalCustomerId: string): Promise<SegmentMembershipHistoryDto[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${segmentsUrl}/segmentmemberships/externalCustomerId/${externalCustomerId}/history`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCustomerRetentionGroupDetail: async (): Promise<AISegmentGroupApiResponse> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerInactivityUrl}/management/group`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  activateCustomerRetentionModel: async (): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${customerInactivityUrl}/management/group/activation`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deactivateRetentionModel: async (): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${customerInactivityUrl}/management/group/deactivation`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCustomerLifetimeValueGroupDetail: async (): Promise<AISegmentGroupApiResponse> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${customerLifetimeValueUrl}/management/group`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  activateCustomerLifetimeValue: async (): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${customerLifetimeValueUrl}/management/group/activation`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deactivateCustomerLifetimeValue: async (): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PATCH");
    return fetchWithTenant(`${customerLifetimeValueUrl}/management/group/deactivation`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  countAffectedMembersBySegments: async (externalSegmentIds: string[]): Promise<number> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${segmentsUrl}/segmentmemberships/count-distinct-members`, {
      ...requestOptions,
      body: JSON.stringify(externalSegmentIds),
    }).then(handleResponse);
  },
  countCustomersByCircleNumbers: async (circleNumbers: string[]): Promise<number> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${customerCareUrl}/customers/count-by-circles`, {
      ...requestOptions,
      body: JSON.stringify(circleNumbers),
    }).then(handleResponse);
  },
  getAllReceipts: async (
    page: number = 1,
    size: number = 10,
    sortBy?: string,
    sortDirection?: string,
    status?: string[]
  ): Promise<PaginatedReceiptResponse> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${receiptScanningUrl}/receipts${objectToQueryString({
        page,
        size,
        sortBy,
        sortDirection,
        status,
      })}`,
      requestOptions
    ).then(handleResponse);
  },
  getReceipt: async (receiptNumber: string): Promise<ReceiptDto> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${receiptScanningUrl}/receipts/${receiptNumber}`, requestOptions).then(handleResponse);
  },
  updateReceipt: async (id: string, data: any): Promise<void> => {
    const requestOptions = await tokenRequestOptions("PUT");
    return fetchWithTenant(`${receiptScanningUrl}/receipts/${id}`, {
      ...requestOptions,
      body: JSON.stringify(data),
    }).then(handleResponse);
  },
  getOtpDevices: async (userNumber: string): Promise<OTPDevice[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(
      `${adminUserManagementUrl}/users/${userNumber}/otp`,
      requestOptions
    ).then(handleResponse);
  },
  removeUserOtpDevice: async (userNumber: string, otpDeviceId: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(
      `${adminUserManagementUrl}/users/${userNumber}/otp/${otpDeviceId}`,
      requestOptions
    ).then(handleResponse);
  },
  rejectReceipt: async (id: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${receiptScanningUrl}/receipts/${id}/reject`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  approveReceipt: async (id: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${receiptScanningUrl}/receipts/${id}/approve`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  assignMembersToCouponTemplate: async (couponTemplateNumber: string, assignment: CouponTemplateAssignmentDto): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}/assign-eligibility`, {
      ...requestOptions,
      body: JSON.stringify(assignment),
    }).then(() => {});
  },
  deleteCouponTemplate: async (couponTemplateNumber: string): Promise<void> => {
    const requestOptions = await tokenRequestOptions("DELETE");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}`, {
      ...requestOptions,
    }).then(() => {});
  },
  createCouponTemplate: async (couponData: CreateCouponTemplateRequest): Promise<void> => {
    // Always use FormData for all coupon creation
    const formData = new FormData();
    
    // Add all fields to FormData
    Object.entries(couponData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (Array.isArray(value)) {
          value.forEach(item => formData.append(key, item));
        } else {
          formData.append(key, String(value));
        }
      }
    });
    
    const requestOptions = await tokenRequestOptionsForMultipart("POST");
    const response = await fetchWithTenant(`${couponUrl}/coupon-templates`, {
      ...requestOptions,
      body: formData,
    });
    
    if (response.status === 204) {
      return;
    }
    
    return handleResponse(response);
  },
  getAllCouponTemplates: async (
    page: number = 1,
    size: number = 10,
    sortBy?: string,
    sortDirection?: string,
    statuses?: string[],
    activationTypes?: string[],
    name?: string
  ): Promise<any> => {
    const requestOptions = await tokenRequestOptions("GET");
    const queryParams = objectToQueryString({
      page,
      size,
      sortBy,
      sortDirection,
      status: statuses,
      activationType: activationTypes,
      name
    });
    return fetchWithTenant(`${couponUrl}/coupon-templates${queryParams}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  getCouponTemplateByNumber: async (couponTemplateNumber: string): Promise<any> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  activateCouponTemplate: async (couponTemplateNumber: string): Promise<any> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}/activate`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  deactivateCouponTemplate: async (couponTemplateNumber: string): Promise<any> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}/deactivate`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  updateCouponTemplate: async (couponTemplateNumber: string, couponData: CreateCouponTemplateRequest): Promise<any> => {
    // Always use FormData for all coupon updates
    const formData = new FormData();
    
    // Add all fields to FormData
    Object.entries(couponData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (Array.isArray(value)) {
          value.forEach(item => formData.append(key, item));
        } else {
          formData.append(key, String(value));
        }
      }
    });
    
    const requestOptions = await tokenRequestOptionsForMultipart("PUT");
    return fetchWithTenant(`${couponUrl}/coupon-templates/${couponTemplateNumber}`, {
      ...requestOptions,
      body: formData,
    }).then(handleResponse);
  },
  getFieldConfigurations: async (): Promise<CustomerFieldConfig[]> => {
    const requestOptions = await tokenRequestOptions("GET");
    return fetchWithTenant(`${segmentsUrl}/easy-segments/field-configurations`, {
      ...requestOptions,
    }).then(handleResponse);
  },
  createEasySegment: async (easySegment: EasySegmentCreateRequest): Promise<void> => {
    const requestOptions = await tokenRequestOptions("POST");
    return fetchWithTenant(`${segmentsUrl}/easy-segments`, {
      ...requestOptions,
      body: JSON.stringify(easySegment),
    }).then(handleResponse);
  },
};

export function objectToQueryString(obj: object) {
  const entries = Object.entries(obj).filter(([_, value]) => value !== undefined);
  return entries.length
    ? `?${entries
        .flatMap(([key, value]) =>
          Array.isArray(value)
            ? value.map((v) => `${key}=${encodeURIComponent(v)}`)
            : `${key}=${encodeURIComponent(value)}`
        )
        .join("&")}`
    : "";
}

function toHubConfig(configGroupKey: ConfigGroupKey, configValue: ConfigValueDto): HubConfigDto {
  return {
    group: configGroupKey,
    key: configValue.key,
    description: configValue.description,
    value: configValue.value,
  };
}

async function handleResponse(response: Response) {
  const text = await response.text();
  let data;
  try {
    // Try to parse the response as JSON only if the content is available
    if (text) {
      data = JSON.parse(text);
    }
  } catch (error) {
    //parsing error
    console.error("Failed to parse response as JSON", error, text);
    throw new Error(
      `The server returned an unexpected response. Please try again later or contact support if the problem persists`
    );
  }

  //check for errors in the response
  const error = data?.error || data?.errors;
  if (error) throw error;

  // A failed response without an error body - a Quarkus 403 sends none - would otherwise be returned as a success and
  // let the caller's thunk report "created" for a write that never happened.
  if (!response.ok) {
    throw new Error(`The request failed with status ${response.status}.`);
  }

  return data;
}

async function handleFileResponse(response: Response, defaultFileName: string) {
  if (response.status === 200) {
    const fileName = response.headers.get("content-disposition")?.split("filename=")[1];

    response.blob().then((blob) => {
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = fileName ?? defaultFileName;
      link.click();
      link.parentNode?.removeChild(link);
    });
    return;
  }
  return handleResponse(response);
}
